<template>
  <div class="report-section report-section-resource-monitor">
    <div v-if="reportData.options?.name || reportData.name" class="section-title">{{ reportData.options?.name || reportData.name }}</div>
    <div v-if="reportData.options?.description || reportData.description" class="section-description">{{ reportData.options?.description || reportData.description }}</div>
    <explorer-index ref="template" v-if="isTemplateEdit" :is-template="true" :is-template-edit="isTemplateEdit" :template-params="{ queryParams: reportData.queryParams || reportData.options?.queryParams, panel }" />
    <dashboard-card
      v-else
      ref="dashboardCard"
      :panel="panel"
      :extraParams="extraParams"
      :time="time"
      :timeGroup="timeGroup"
      is-template
      @fetchDataSuccess="handleMonitorFetchSuccess" />
  </div>
</template>

<script>
import ExplorerIndex from '@Monitor/views/explorer/components/index.vue'
import DashboardCard from '@Monitor/components/MonitorCard/DashboardCard'

export default {
  name: 'ReportResourceMonitor',
  components: {
    ExplorerIndex,
    DashboardCard,
  },
  props: {
    reportData: {
      type: Object,
      default: () => ({}),
    },
    isTemplateEdit: {
      type: Boolean,
      default: false,
    },
    scopeParams: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    const model = this.reportData.queryParams?.model || this.reportData.options?.queryParams?.model || {}
    let from = this.reportData.queryParams?.time || this.reportData.options?.queryParams?.time || '1h'
    let to = 'now'
    if (from === 'last_month') {
      const now = this.$moment()
      const lastMonthStart = this.$moment().subtract(1, 'month').startOf('month') // 上个月1号0点
      const lastMonthEnd = this.$moment().subtract(1, 'month').endOf('month') // 上个月最后一天最后一刻

      // from: 当前时间距离上个月1号0点多少个小时
      const fromHours = now.diff(lastMonthStart, 'hours')
      // to: 当前时间距离上个月最后一天最后一刻多少个小时
      const toHours = now.diff(lastMonthEnd, 'hours')
      from = `${fromHours}h`
      to = `${toHours}h`
    }
    const tags = model.tags || []
    // if (this.scopeParams.project_id) {
    //   tags.push({
    //     key: 'project_id',
    //     value: this.scopeParams.project_id,
    //     operator: '=',
    //   })
    // }
    if (this.scopeParams.domain_id) {
      tags.push({
        key: 'domain_id',
        value: this.scopeParams.domain_id,
        operator: '=',
      })
    }
    if (tags.length) {
      model.tags = tags
    }
    return {
      extraParams: {
        scope: this.scopeParams.scope || this.$store.getters.scope,
      },
      panel: {
        panel_name: this.reportData.queryParams?.panel_name || this.reportData.options?.queryParams?.panel_name || 'CPU使用率',
        queryData: {
          scope: this.$store.getters.scope,
        },
        setting: {
          conditions: [
            {
              operator: '=',
              type: 'query',
              query: {
                from,
                to,
                model,
                result_reducer: this.reportData.queryParams?.result_reducer || this.reportData.options?.queryParams?.result_reducer || '',
              },
            },
          ],
        },
        common_alert_metric_details: this.reportData.queryParams?.common_alert_metric_details || this.reportData.options?.queryParams?.common_alert_metric_details || [],
      },
      time: from,
      timeGroup: this.reportData.queryParams?.timeGroup || this.reportData.options?.queryParams?.timeGroup || '5m',
    }
  },
  methods: {
    getTemplateParams () {
      return this.$refs.template.getTemplateParams()
    },
    handleMonitorFetchSuccess () {
      if (this.isTemplateEdit) return
      const card = this.$refs.dashboardCard
      this.$emit('resourceListHidden', this.isMonitorDataEmpty(card))
    },
    isMonitorDataEmpty (card) {
      if (!card) return true
      const series = card.series || []
      const hasPoints = series.some(s => Array.isArray(s.points) && s.points.length > 0)
      if (hasPoints) return false
      const reduced = card.reducedResult || {}
      const hasReduced = Object.keys(reduced).some((key) => {
        const val = reduced[key]
        return Array.isArray(val) ? val.length > 0 : val != null && val !== ''
      })
      if (hasReduced) return false
      return (card.pager?.total ?? 0) === 0
    },
  },
}
</script>

<style lang="less" scoped>
.section-title {
  color: #000;
  font-size: 18px;
  font-weight: bold;
  padding-bottom: 5px;
  border-bottom: 2px solid rgba(0, 0, 0, 0.5);
  margin-bottom: 15px;
}
.section-description {
  color: #666;
  font-size: 14px;
  margin-bottom: 15px;
}
</style>
